import React from "react";
import { Space, Button, Tooltip, Popconfirm, Upload, Typography } from "antd";
import {
  EyeOutlined,
  DownloadOutlined,
  UploadOutlined,
  DeleteOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import { urlDescargaSoporte } from "../../services/novedad_participante/novedadParticipanteService";

const { Text } = Typography;

const formatPeso = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/**
 * Fila de un soporte: ver (inline), descargar, reemplazar (sube un archivo
 * nuevo en el lugar del actual) y eliminar (soft delete). Cada acción se
 * gobierna por su propio permiso (appName novedad_participante: priv_print
 * → ver/descargar, priv_update → reemplazar, priv_delete → eliminar).
 */
const SoporteItem = ({
  soporte,
  onReemplazar,
  onEliminar,
  permitirVer = true,
  permitirReemplazar = true,
  permitirEliminar = true,
  cargando = false,
}) => {
  const uploadProps = {
    showUploadList: false,
    multiple: false,
    beforeUpload: (file) => {
      onReemplazar?.(file);
      return false;
    },
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 12px",
        border: "1px solid #f0f0f0",
        borderRadius: 6,
        marginBottom: 8,
      }}
    >
      <Space size={8} style={{ overflow: "hidden" }}>
        <PaperClipOutlined style={{ color: "#8c8c8c" }} />
        <Text ellipsis style={{ maxWidth: 220 }} title={soporte.nombre_original}>
          {soporte.nombre_original}
        </Text>
        <Text type="secondary" style={{ fontSize: 12 }}>
          {formatPeso(soporte.peso_bytes)}
        </Text>
      </Space>

      <Space size={4}>
        {permitirVer && (
          <>
            <Tooltip title="Ver">
              <Button
                size="small"
                icon={<EyeOutlined />}
                onClick={() => window.open(urlDescargaSoporte(soporte.id, "ver"), "_blank", "noopener")}
              />
            </Tooltip>
            <Tooltip title="Descargar">
              <Button
                size="small"
                icon={<DownloadOutlined />}
                onClick={() => window.open(urlDescargaSoporte(soporte.id, "descargar"), "_blank", "noopener")}
              />
            </Tooltip>
          </>
        )}
        {permitirReemplazar && (
          <Upload {...uploadProps}>
            <Tooltip title="Reemplazar archivo">
              <Button size="small" icon={<UploadOutlined />} loading={cargando} />
            </Tooltip>
          </Upload>
        )}
        {permitirEliminar && (
          <Popconfirm
            title="¿Eliminar este soporte?"
            okText="Eliminar"
            cancelText="Cancelar"
            onConfirm={onEliminar}
          >
            <Tooltip title="Eliminar">
              <Button size="small" danger icon={<DeleteOutlined />} loading={cargando} />
            </Tooltip>
          </Popconfirm>
        )}
      </Space>
    </div>
  );
};

export default SoporteItem;
